import React from 'react';
import { API_URL } from '../Utils/Constant';
import { FiEdit2, FiTrash2, FiRefreshCw, FiSearch } from 'react-icons/fi';

const BlogDashboard = ({ 
    blogs, 
    filteredBlogs, 
    loading, 
    error, 
    searchQuery, 
    setSearchQuery, 
    handleRefresh, 
    handleEdit, 
    handleDelete 
}) => {
    return (
        <div className="p-6">
            <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
                <h2 className="text-2xl font-bold text-gray-800">All Blogs</h2>
                <div className="flex gap-4 w-full md:w-auto">
                    <div className="relative flex-1 md:w-64">
                        <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                        <input
                            type="text"
                            placeholder="Search blogs..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-secondary focus:border-transparent"
                        />
                    </div>
                    <button
                        onClick={handleRefresh}
                        disabled={loading}
                        className={`px-4 py-2 bg-secondary text-white rounded-lg hover:bg-secondary/90 transition-colors flex items-center gap-2 ${loading ? 'opacity-75 cursor-not-allowed' : ''
                            }`}
                    >
                        <FiRefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
                        {loading ? 'Refreshing...' : 'Refresh'}
                    </button>
                </div>
            </div>
            {loading ? (
                <div className="flex justify-center items-center h-64">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-secondary"></div>
                </div>
            ) : error ? (
                <div className="bg-red-50 border-l-4 border-red-500 p-4">
                    <p className="text-red-700">{error}</p>
                </div>
            ) : (
                <div className="grid grid-cols-1 gap-6">
                    {filteredBlogs.map((blog) => (
                        <div key={blog._id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                            <div className="flex flex-col md:flex-row">
                                <div className="md:w-1/3">
                                    <img
                                        src={blog.image}
                                        alt={blog.title}
                                        className="w-full h-48 object-fill"
                                    />
                                </div>
                                <div className="md:w-2/3 p-4">
                                    <h3 className="text-xl font-semibold mb-2 text-gray-800">{blog.title}</h3>
                                    <p className="text-gray-600 mb-4 line-clamp-2">{blog.content}</p>
                                    <div className="flex justify-between items-center">
                                        <span className="text-sm text-gray-500">By {blog.author}</span>
                                        <div className="flex gap-2">
                                            <button
                                                onClick={() => handleEdit(blog)}
                                                className="p-2 text-blue-600 hover:bg-blue-50 rounded-full transition-colors"
                                            >
                                                <FiEdit2 className="w-5 h-5" />
                                            </button>
                                            <button
                                                onClick={() => handleDelete(blog._id)}
                                                className="p-2 text-red-600 hover:bg-red-50 rounded-full transition-colors"
                                            >
                                                <FiTrash2 className="w-5 h-5" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default BlogDashboard;
